"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.PunchSpinner = void 0;
const react_1 = __importDefault(require("react"));
const Spinner_1 = require("@amzn/atoz-web/Spinner");
const View_1 = require("@amzn/atoz-web/View");
const Theme_1 = require("@amzn/atoz-web/Theme");
const PunchSpinner = () => {
    return (react_1.default.createElement(SpinnerContainer, { dataTestId: "PunchSpinner" },
        react_1.default.createElement(Spinner_1.Spinner, { size: Spinner_1.SpinnerSize.Large })));
};
exports.PunchSpinner = PunchSpinner;
const SpinnerContainer = (0, Theme_1.styledWithTheme)(View_1.View)(`
    position: fixed;
    display: flex;
    align-items: center;
    justify-content: center;
    height: 100vh;
    width: 100vw;
    top: 0;
    left: 0;
    z-index: 9999;
    background: rgba(0, 0, 0, 0.2);
  `);
